import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// action types
export const JOB_WORKFLOW_FETCH_TABLE_DATA =
  'jobWorkflowAdmin/JOB_WORKFLOW_FETCH_TABLE_DATA'
export const [
  JOB_WORKFLOW_FETCH_TABLE_DATA_SUCCESS,
  JOB_WORKFLOW_FETCH_TABLE_DATA_FAILURE,
] = [
  `${JOB_WORKFLOW_FETCH_TABLE_DATA}_SUCCESS`,
  `${JOB_WORKFLOW_FETCH_TABLE_DATA}_FAILURE`,
]
export const JOB_WORKFLOW_DELETE = 'jobWorkflowAdmin/DELETE'
export const JOB_WORKFLOW_CLEAR_STATE_LIST =
  'jobWorkflowAdmin/JOB_WORKFLOW_CLEAR_STATE_LIST'
export const JOB_WORKFLOW_CLEAR_STATE_FORM =
  'jobWorkflowAdmin/JOB_WORKFLOW_CLEAR_STATE_FORM'
export const JOB_WORKFLOW_CLEAR_STATE = 'jobWorkflowAdmin/CLEAR_STATE'
export const JOB_WORKFLOW_CHANGE = 'jobWorkflowAdmin/JOB_WORKFLOW_CHANGE'
export const JOB_WORKFLOW_POSITION_UPDATE_FETCH =
  'jobWorkflowAdmin/JOB_WORKFLOW_POSITION_UPDATE_FETCH'
export const JOB_WORKFLOW_POSITION_UPDATE_SUCCESS =
  'jobWorkflowAdmin/JOB_WORKFLOW_POSITION_UPDATE_SUCCESS'
export const LOAD_JOB_WORKFLOW_FORM = 'jobWorkflowAdmin/LOAD_JOB_WORKFLOW_FORM'
export const JOB_WORKFLOW_FETCH_FORM_DATA =
  'jobWorkflowAdmin/JOB_WORKFLOW_FETCH_FORM_DATA'
export const [
  JOB_WORKFLOW_FETCH_FORM_DATA_SUCCESS,
  JOB_WORKFLOW_FETCH_FORM_DATA_FAILURE,
] = [
  `${JOB_WORKFLOW_FETCH_FORM_DATA}_SUCCESS`,
  `${JOB_WORKFLOW_FETCH_FORM_DATA}_FAILURE`,
]
export const JOB_WORKFLOW_COPY_DATA = 'jobWorkflowAdmin/JOB_WORKFLOW_COPY_DATA'
export const [
  JOB_WORKFLOW_COPY_DATA_SUCCESS,
  JOB_WORKFLOW_COPY_DATA_FAILURE,
] = [`${JOB_WORKFLOW_COPY_DATA}_SUCCESS`, `${JOB_WORKFLOW_COPY_DATA}_FAILURE`]
export const JOB_WORKFLOW_TRIGGERED_BY =
  'jobWorkflowAdmin/JOB_WORKFLOW_TRIGGERED_BY'

// actions
export const jobWorkflowFetchTableData = ActionHelper.createActionObj(
  JOB_WORKFLOW_FETCH_TABLE_DATA,
)
export const jobWorkflowFetchFormData = ActionHelper.createActionObj(
  JOB_WORKFLOW_FETCH_FORM_DATA,
)
export const jobWorkflowClearState = ActionHelper.createActionObj(
  JOB_WORKFLOW_CLEAR_STATE,
)
export const jobWorkflowClearStateList = ActionHelper.createActionObj(
  JOB_WORKFLOW_CLEAR_STATE_LIST,
)
export const jobWorkflowClearStateForm = ActionHelper.createActionObj(
  JOB_WORKFLOW_CLEAR_STATE_FORM,
)
export const jobWorkflowChange = ActionHelper.createActionObj(
  JOB_WORKFLOW_CHANGE,
)
export const jobWorkflowDelete = ActionHelper.createActionObj(
  JOB_WORKFLOW_DELETE,
)
export const jobWorkflowPositionUpdate = ActionHelper.createActionObj(
  JOB_WORKFLOW_POSITION_UPDATE_FETCH,
)
export const jobWorkflowCopyData = ActionHelper.createActionObj(
  JOB_WORKFLOW_COPY_DATA,
)
export const jobWorkflowTriggeredBy = ActionHelper.createActionObj(
  JOB_WORKFLOW_TRIGGERED_BY,
)

const initialState = Immutable.fromJS({
  isLoadForm: false,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {},
})

const jobWorkflow = handleActions(
  {
    [combineActions(JOB_WORKFLOW_CLEAR_STATE, RESET_STORE)]: () => initialState,
    [JOB_WORKFLOW_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [LOAD_JOB_WORKFLOW_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [JOB_WORKFLOW_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [JOB_WORKFLOW_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [JOB_WORKFLOW_POSITION_UPDATE_SUCCESS]: (
      state,
      { payload: { index, position } },
    ) => {
      const { data, count } = state.get('tableData').toJS()
      data[index].position = position

      return state.set(
        'tableData',
        Map({
          data,
          count,
        }),
      )
    },
    [JOB_WORKFLOW_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
  },
  initialState,
)

export default jobWorkflow
